import Vue from 'vue'
import Vuex from 'vuex'

import VuexPersistence from 'vuex-persist'
const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})


// 安装插件
Vue.use(Vuex)
// 创建Store对象
const store = new Vuex.Store({
    plugins: [
        vuexLocal.plugin
    ],
    state: {
        apikey:'FG8orFhD0x2DWt5T4qgoNhvtXTfX4V',
        userName: "",
        userLimit: "0"
    },
    mutations: {
        loginName(state,user_name) {
            state.user.userName = user_name;
        },
        loginLimit(state,user_limit) {
            state.user.userLimit = user_limit;
        }
    },
    actions: {
        loginName() {
            
        }
    }
})

// 挂载Vue实例上
export default store
